import { render, staticRenderFns } from "./Fortune.vue?vue&type=template&id=e1a9f9aa&scoped=true&"
import script from "./Fortune.vue?vue&type=script&lang=js&"
export * from "./Fortune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a9f9aa",
  null
  
)

export default component.exports